export default __webpack_public_path__ + "static/media/habano-4Open.fe7b82b8.jpg";